@if (paymentData$ | async; as paymentData) {
  <div class="mt-4 text-xs">
    <div class="ml-12 flex">
      <div class="w-32 flex-initial pl-1.5 pr-1.5 text-right text-xxs font-bold">{{ title }}</div>
      @for (data of paymentData; track data) {
        <div class="flex-1 overflow-hidden pl-1.5 pr-1.5 text-center tabular-nums">
          {{ data[historyKey] | money }}
        </div>
      }
    </div>
  </div>
}
